import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const CmsTileModalMobileHeaderHolder = styled.div`
  width: 100%;
  height: 72px;
  flex-shrink: 0;
  background: white;
  box-shadow: 0 0 20px rgb(0 0 0 / 10%);
  padding: 0 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 31px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-bottom: 48px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const CmsTileModalMobileHeaderArrowsHolder = styled.div`
  display: flex;
  align-items: center;

  > *:not(:first-of-type) {
    margin-left: 49px;
  }

  @media all and (max-width: ${cssBreakpoints.smDown}) {
    > *:not(:first-of-type) {
      margin-left: 44px;
    }
  }
`;
